import React, { useState } from 'react';
import Modal, { buttonClass, primaryButtonClass, inputClass, labelClass } from 'features/dashboards/components/Modal';
import { errorText } from 'features/dashboards/format';

/**
 * A dashboard's name and description — creating one, or changing them.
 * @param {{ initial?: {name?: string, description?: string}, title: string, confirmLabel: string,
 *           onSubmit: (v: {name: string, description: string}) => Promise<void>, onClose: () => void }} props
 */
export default function DashboardDetailsDialog({ initial = {}, title, confirmLabel, onSubmit, onClose }) {
  const [name, setName] = useState(initial.name || '');
  const [description, setDescription] = useState(initial.description || '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    if (e) e.preventDefault();
    if (!name.trim() || busy) return;
    setBusy(true); setError(null);
    try { await onSubmit({ name: name.trim(), description: description.trim() }); onClose(); } catch (err) { setError(errorText(err)); setBusy(false); }
  };

  return (
    <Modal title={title} onClose={onClose} width="max-w-md"
      footer={(
        <>
          <button type="button" className={buttonClass} onClick={onClose}>Cancel</button>
          <button type="submit" form="dash-details" className={primaryButtonClass} disabled={busy || !name.trim()}>{confirmLabel}</button>
        </>
      )}>
      <form id="dash-details" onSubmit={submit} className="space-y-3 px-4 py-4">
        {error ? <div className="rounded-lg border border-[color:var(--feedback-error)] bg-[color:var(--feedback-error-bg)] px-3 py-2 text-[12px] text-[color:var(--feedback-error)]">{error}</div> : null}
        <div>
          <label className={labelClass} htmlFor="dash-name">Name</label>
          {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
          <input id="dash-name" autoFocus className={inputClass} value={name} maxLength={120} onChange={(e) => setName(e.target.value)} placeholder="Checkout agent" />
        </div>
        <div>
          <label className={labelClass} htmlFor="dash-description">Description <span className="font-normal">(optional)</span></label>
          <textarea id="dash-description" rows={3} maxLength={2000} value={description} onChange={(e) => setDescription(e.target.value)}
            placeholder="What this board tracks and who it is for"
            className="w-full resize-none rounded-md border border-[color:var(--border-default)] bg-surface px-2.5 py-2 text-[12px] leading-relaxed text-[color:var(--text-primary)] outline-none focus:border-[color:var(--brand-primary)]"
            onKeyDown={(e) => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) submit(); }} />
        </div>
      </form>
    </Modal>
  );
}
